<template>
  <div
    class="m-guest top-nav"
    :style="{
      backgroundColor: extras.meetingGuest
        ? extras.meetingGuest.bg
        : defaultColor,
    }"
    v-if="extras && extras.meetingGuest.display == 1"
    id="meetingGuest"
  >
    <WapTitle
      v-if="extras.meetingGuestTitle.display == 1"
      :title="extras.meetingGuestTitle.model || title"
      :icon="icon"
      :titleFont="extras.meetingGuestTitle.color"
    />
    <carousel3d
      :autoplay="false"
      :height="carouselData.height"
      :width="carouselData.width"
      :style="{ height: carouselData.height + 30 + 'px' }"
      v-if="guests.length > 0"
    >
      <slide v-for="(guest, index) in guests" :key="index" :index="index">
        <div class="slide-con">
          <img
            class="guest-header"
            :src="guest.realPath || defaultHeader"
            :alt="guest.name"
          />
          <div class="guest-name">{{ guest.name }}</div>
          <div class="guest-intro">{{ guest.enterprise }}</div>
          <div class="guest-intro-duty textcenter">{{ guest.duty }}</div>
        </div>
      </slide>
    </carousel3d>

    <div class="no-data" v-if="guests && guests.length == 0">
      <img :src="require('@/assets/images/nodata.png')" />
      <div class="no-data-text">暂无数据</div>
    </div>
  </div>
</template>

<script>
import WapTitle from "@/components/index/WapTitle.vue";
import { Carousel3d, Slide } from "@/components/home/carousel-3d";
export default {
  components: {
    WapTitle,
    Carousel3d,
    Slide,
  },
  props: {
    guests: [],
    extras: Object,
  },
  data() {
    return {
      num: 0,
      defaultHeader: require("../../assets/images/wap/default.jpg"),
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 30,
        centeredSlides: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      icon: require("@/assets/images/wap/jiabin.png"),
      title: "参会嘉宾",
      carouselData: {
        height: 300,
        width: 250,
      },
      defaultColor: "#ffffff",
    };
  },
  methods: {},
  mounted() {
    console.log("clientWidth", document.body.clientWidth);
    this.carouselData.width = (document.body.clientWidth + 1) / 1.8;
    this.carouselData.height = this.carouselData.width * 1.2;
    if (this.guests.length == 2) {
      this.guests = this.guests.push(this.guests[0]);
    }
  },
};
</script>
<style lang="scss" scoped>
.swiper-container {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 300ms;
  transform: scale(0.8);
}
.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1);
}
</style>
